let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("3ggW0")).then(() => parcelRequire('tPMRe'));